import React from 'react';
import { useIntl } from 'react-intl';

import { sendTrackingEvent } from '../../helpers';
import { getSetting } from '../../helpers/Settings';

const UploadPageFooter = () => {
  const intl = useIntl();
  const workspace = getSetting('domain');

  const trackClick = () => {
    sendTrackingEvent('guest-upload-page-cta-button-clicked');
  };

  return (
    <footer className="footer mt-auto py-5">
      <div className="footer-message d-flex justify-content-center text-center p-5">
        <div className="text-muted">
          <p className="mb-0">
            {intl.formatMessage({ defaultMessage: 'Your files will be uploaded securely to the {workspace}, but why stop there?' }, { workspace })}
          </p>
          <p className="mb-4">
            {intl.formatMessage({ defaultMessage: 'See how Stockpress helps teams stay organized. Learn more <link>here</link>.' }, {
              link: (msg) => (
                <a target="_blank" rel="noopener noreferrer" href="https://hubs.li/Q0381MSN0" onClick={trackClick}>{msg}</a>
              ),
            })}
          </p>
          <div className="mb-3">
            <a href="https://hubs.li/Q0381MSN0" target="_blank" rel="noopener noreferrer" onClick={trackClick}>
              <img src="/images/stockpress-brand-mark-v2.png" alt="Stockpress" width={42} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default UploadPageFooter;
